import { EMPLOYEE_STATUS_CONFIG } from "@/constants/employees";
import type { EmployeeStatus } from "@/types";

interface EmployeeStatusBadgeProps {
  status: EmployeeStatus;
}

export default function EmployeeStatusBadge({
  status,
}: EmployeeStatusBadgeProps) {
  const config = EMPLOYEE_STATUS_CONFIG[status];
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold whitespace-nowrap ${config.className}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${config.dot}`}></span>
      {config.label}
    </span>
  );
}